import React from 'react';

import { IconSearch } from '../Icon';
import { Icon, Input, Wrapper } from './wrapper';

type InputTextProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {};

const InputSearch = ({ ...props }: Omit<InputTextProps, 'ref'>) => (
  <Wrapper>
    <Icon>
      <IconSearch />
    </Icon>
    <Input {...props} />
  </Wrapper>
);

export default InputSearch;
